import Global from "../../models/global";

const General = (state = Global, action) => {
    switch (action.type) {
        case 'global':
            return {
                ...state,
				...action.global
            }
    
        default:
            return state;
    }
}

export default General;